import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useFormik, Field, ErrorMessage, FormikProvider, FieldArray } from "formik";
import * as Yup from "yup";
import MembersTable from "./MembersTable";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { config } from "../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats, handlePaste } from "../CommonUtils/CommonValidations";
import { ERROR_MSG, MOBILE_VALIDATION } from "../CommonUtils/contextVariables";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { FaEye } from "react-icons/fa";
import { viewImage } from "../CommonUtils/viewImage";

import * as bie from "react-bootstrap";

const ManagementApplication = ({ goNext, paymentDone }) => {

  const [distlist, setDistlist] = useState([]);

  function GetDisData() {
    CommonAxiosGet(`${config.url.FAC_URL}getdistrictsOld`).then((res) => {
      setDistlist(res?.data?.scode === "01" ? res.data.districtmst || [] : []);
    });
  }

  const [mdllist, setMdltlist] = useState([]);

  function GetMandlData(distcode) {
    if (!distcode) {
      return
    }
    CommonAxiosGet(`${config.url.FAC_URL}getmandalsOld/${distcode}`).then((res) => {
      setMdltlist(res?.data?.scode === "01" ? res.data.mandalmst || [] : []);
    });

  }

  // let Url = config.url.API_URL + "getvillages/" + distCode + "/" + mandalCode;
  const [vilglist, setVilglist] = useState([]);

  function GetVillegeData(distcode, mdlcode) {
    if (!distcode || !mdlcode) {
      return
    }
    CommonAxiosGet(`${config.url.FAC_URL}getvillagesOld/${distcode}/${mdlcode}`).then((res) => {
      setVilglist(res?.data?.scode === "01" ? res?.data?.villagemst || [] : []);
    });

  }
  const formik = useFormik({
    initialValues: {
      natureOfChange: "",
      currentName: "",
      proposedName: "",
      currentAddress: "",
      newAddress: "",
      reason: "",
      manageType: "management",
      society: "",
      totalLand: "",
      distCode: "",
      mandalCode: "",
      villageCode: "",
      surveyNo: "",
      planbymroUpload: "",
      distanceland: "",
      changeMangement: "",
      Chairperson: [
        {
          name: "",
          address: "",
          mobile: "",
          role: "",
          responsibilities: "",
        },

      ],

      Members: [
        {
          name: "",
          address: "",
          mobile: "",
          role: "",
          responsibilities: "",
        },
      ],
    },

    // validationSchema: Yup.object({


    //   currentName: Yup.string().required(ERROR_MSG),

    //   proposedName: Yup.string()
    //     .required(ERROR_MSG)
    //     .notOneOf([Yup.ref("currentName")], "Proposed name should be different from current name"),

    //   currentAddress: Yup.string().when("natureOfChange", {
    //     is: "address",
    //     then: (schema) => schema.required(ERROR_MSG),
    //   }),

    //   // newAddress: Yup.string()
    //   //     .when("natureOfChange", {
    //   //         is: "address",
    //   //         then: (schema) => schema.required("Enter New Address")
    //   //     }),

    //   reason: Yup.string().min(10, "Reason must be at least 10 characters").required(ERROR_MSG),

    //   Chairperson: Yup.array().of(
    //     Yup.object().shape({
    //       name: Yup.string().required(ERROR_MSG),

    //       address: Yup.string().required(ERROR_MSG),

    //       mobile: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number"),

    //       // role: Yup.string().required(ERROR_MSG),

    //       responsibilities: Yup.string().required(ERROR_MSG),
    //     }),
    //   ),

    //   Members: Yup.array().of(
    //     Yup.object().shape({
    //       name: Yup.string().required(ERROR_MSG),

    //       address: Yup.string().required(ERROR_MSG),

    //       mobile: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number"),

    //       role: Yup.string().required(ERROR_MSG),

    //       responsibilities: Yup.string().required(ERROR_MSG),
    //     }),
    //   ),
    // }),

    validationSchema: Yup.object({
      // currentName: Yup.string().required(ERROR_MSG),

      proposedName: Yup.string()
        .required(ERROR_MSG)
        .notOneOf([Yup.ref("currentName")], "Proposed name should be different from current name"),

      reason: Yup.string()
        .min(10, "Reason must be at least 10 characters")
        .required(ERROR_MSG),

      newAddress: Yup.string().when("natureOfChange", {
        is: "address",
        then: (schema) => schema.required("Enter New Address"),
      }),

      // ✅ Chairperson (Secretary)
      Chairperson: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(ERROR_MSG),
          address: Yup.string().required(ERROR_MSG),
          mobile: Yup.string()
            .required(ERROR_MSG)
            .matches(MOBILE_VALIDATION, "Invalid mobile number"),
          responsibilities: Yup.string().required(ERROR_MSG),
        })
      ),

      // ✅ Members
      Members: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(ERROR_MSG),
          address: Yup.string().required(ERROR_MSG),
          mobile: Yup.string()
            .required(ERROR_MSG)
            .matches(MOBILE_VALIDATION, "Invalid mobile number"),
          role: Yup.string().required("Select Role"),
          responsibilities: Yup.string().required(ERROR_MSG),
        })
      ),

      // ✅ Land Details
      society: Yup.string().required("Select Yes/No"),

      totalLand: Yup.number()
        .typeError("Enter valid number")
        .required(ERROR_MSG),

      surveyNo: Yup.string().required(ERROR_MSG),

      distCode: Yup.string().required("Select District"),

      mandalCode: Yup.string().required("Select Mandal"),

      villageCode: Yup.string().required("Select Village"),
      planbymroUpload: Yup.string().required("Required"),

      distanceland: Yup.number()
        .typeError("Enter valid distance")
        .required(ERROR_MSG),

      changeMangement: Yup.string().required("Select option"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const getTrustDetails = async () => {
    let url = config.url.FAC_URL + "getSocietyNameChange";

    CommonAxiosGet(url).then((res) => {
      if (res !== null && res.data.status === true) {
        let societyData = res.data.societyName;
        let chairPersons = res.data.chairPerson;
        let boardMembers = res.data.boardOfGoverners;

        let societyStatus = res.data.societyName_status;
        let chairStatus = res.data.chairPerson_status;
        let boardStatus = res.data.boardOfGoverners_status;

        // ✅ If ANY data exists → disable form
        if (societyStatus || chairStatus || boardStatus) {
          if (societyStatus) {
            let society = societyData[0];

            const changeType =
              society.name_address_change === "Name Change" ? "name" : "address";


            formik.setValues((prev) => ({
              ...prev,
              natureOfChange: changeType,
              currentName: society.current_name_of_trust || "",
              proposedName: society.proposed_new_name || "",
              currentAddress: society.current_address || "",
              newAddress: society.new_address || "",
              reason: society.reason_for_change || "",

              society: society.society || "",
              totalLand: society.total_land || "",
              distCode: society.dist_code || "",
              mandalCode: society.mandal_code || "",
              villageCode: society.village_code || "",
              surveyNo: society.survey_no || "",
              planbymroUpload: society.planbymro_upload || "",
              distanceland: society.distanceland || "",
              changeMangement: society.change_management || "",
            }));

            if (society.dist_code) {
              GetMandlData(society.dist_code);
            }
            if (society.dist_code && society.mandal_code) {
              GetVillegeData(society.dist_code, society.mandal_code);
            }
          } if (chairStatus) {
            const chairData = chairPersons
              .filter((item) => item.name_of_chairperson) // ❗ remove empty row
              .map((item) => ({
                name: item.name_of_chairperson || "",
                address: item.address || "",
                mobile: item.contact || "",
                role: item.role || "",
                responsibilities: item.responsibilities || "",
              }));
            formik.setFieldValue("Chairperson", chairData);
          } if (boardStatus) {
            const membersData = boardMembers.map((item) => ({
              name: item.name_of_chairperson || "",
              address: item.address || "",
              mobile: item.contact || "",
              role: item.role || "",
              responsibilities: item.responsibilities || "",
            }));

            formik.setFieldValue("Members", membersData);
          }
        } else {
          setAlreadySubmitted(false);
        }
      }
    });
  };

  function getBasicDetails() {
    let url = config.url.FAC_URL + "getSocietyDetails";
    CommonAxiosGet(url).then((res) => {
      if (res !== null && res.data.status === true) {
        let data = res.data.data;
        if (data && data.length > 0) {
          let item = data[0];
          formik.setFieldValue("currentName", item.society_name);
          formik.setFieldValue("currentAddress", item.society_addr);
          if (item.society_name || item.society_addr) {
            setAlreadySubmitted(true);
          } else {
            setAlreadySubmitted(false);
          }

          setAlreadySubmitted(true);
        } else {
          setAlreadySubmitted(false);
        }
      } else {
        setAlreadySubmitted(false);
      }
    });
  }
  useEffect(() => {
    getTrustDetails();
    getBasicDetails();
  }, []);

  const handleSubmit = (values) => {
    Swal.fire({
      text: 'Are you sure you want to submit?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'No, cancel!',
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          nameAddressChange: values.natureOfChange === "name" ? "Name Change" : "Address Change",
          currentNameOfTrust: values.currentName,
          proposedNewName: values.proposedName,
          reasonForChange: values.reason,
          newAddress: values.newAddress,
          currentAddress: values.currentAddress,
          manageType: "management",

          society: values.society,
          totalLand: values.totalLand,
          distCode: values.distCode,
          mandalCode: values.mandalCode,
          villageCode: values.villageCode,
          surveyNo: values.surveyNo,
          planbymroUpload: values.planbymroUpload,
          distanceland: values.distanceland,
          changeMangement: values.changeMangement,

          chairPerson: values.Chairperson.map((item) => ({
            nameOfChairperson: item.name,
            address: item.address,
            contact: item.mobile,
            role: item.role,
            responsibilities: item.responsibilities,
          })),
          governer: values.Members.map((item) => ({
            nameOfChairperson: item.name,
            address: item.address,
            contact: item.mobile,
            role: item.role,
            responsibilities: item.responsibilities,
          })),
        };
        let url = config.url.FAC_URL + "postSocietyName";
        CommonAxiosPost(url, payload).then((res) => {
          if (res?.data?.status === true) {
            if (res.data.scode === "01") {

              successAlert2(res?.data?.sdesc);
              goNext();
            }
          } else {
            failureAlert(res.data.sdesc);
          }
        })

      }
    });
  };



  useEffect(() => {
    GetDisData();
  }, [])

  console.log("formik", formik?.errors)


  return (
    <>
      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit} onChange={formik?.handleChange}>
              <Row>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                  <Form.Label>
                    Handing Over Society  <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Field type="text" name="currentName" className="form-control" disabled />
                  <ErrorMessage name="currentName" component="div" className="text-danger" />
                </Col>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                  <Form.Label>
                    Name of the Taken over Society  <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Field
                    type="text"
                    name="proposedName"
                    className="form-control"
                    // disabled={alreadySubmitted}
                    onKeyPress={allowAlphabetAndSpacesOnly}
                    maxLength={200}
                  />
                  <ErrorMessage name="proposedName" component="div" className="text-danger" />
                </Col>

                <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                  <Form.Label>Address of the Handing Over Society</Form.Label>
                  <Field type="text" name="currentAddress" className="form-control" disabled />
                </Col>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                  <Form.Label>New Address (if changed)</Form.Label>
                  <Field
                    type="text"
                    name="newAddress"
                    className="form-control"
                  // disabled={alreadySubmitted}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <Form.Label>
                    <b>
                      {" "}
                      Reason for Change <span style={{ color: "red" }}>*</span>
                    </b>
                  </Form.Label>
                  <Field
                    name="reason"
                    as="textarea"
                    rows={4}
                    placeholder="Please provide detailed justification for the change..."
                    className={`form-control ${formik.touched.justification && formik.errors.justification ? "is-invalid" : ""}`}
                    style={{ height: "120px", resize: "vertical" }}
                  // disabled={alreadySubmitted}
                  />
                  <ErrorMessage name="reason" component="div" className="text-danger" />
                </Col>
              </Row>
              {/* <h5 className="mb-3 innerheader-new"><span><b> Secretary / Chairperson </b></span></h5>
                    <MembersTable
                        title="Chairperson / Members of Trust/Society/Company"
                        name="Chairperson"
                        formik={formik}
                        disabled={alreadySubmitted}
                    /> */}

              <h5 className="mb-3 innerheader-new pt-3">
                <span>
                  <b>Secretary  Details</b>
                </span>
              </h5>

              <table className="table table-bordered mt-2">
                <thead className="table-primary">
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Contact No.</th>
                    <th>Role</th>
                    <th>Responsibilities</th>
                  </tr>
                </thead>

                <tbody>
                  {formik.values.Chairperson.slice(0, 1).map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td>
                        <Field
                          name={`Chairperson.${index}.name`}
                          className="form-control"
                          onKeyPress={allowAlphabetAndSpacesOnly}
                          maxLength={200}
                        // disabled={alreadySubmitted}
                        />
                        <ErrorMessage name={`Chairperson.${index}.name`} component="div" className="text-danger" />
                      </td>

                      <td>
                        <Field
                          name={`Chairperson.${index}.address`}
                          className="form-control"
                        // disabled={alreadySubmitted}
                        />
                        <ErrorMessage name={`Chairperson.${index}.address`} component="div" className="text-danger" />
                      </td>

                      <td>
                        <Field
                          name={`Chairperson.${index}.mobile`}
                          className="form-control"
                          // disabled={alreadySubmitted}
                          maxLength={10}
                          onKeyPress={allowNumbersOnly}
                          onPaste={handlePaste}
                        />
                        <ErrorMessage name={`Chairperson.${index}.mobile`} component="div" className="text-danger" />
                      </td>

                      <td> Secretary </td>

                      <td>
                        <Field
                          name={`Chairperson.${index}.responsibilities`}
                          className="form-control"
                          // disabled={alreadySubmitted}
                          onKeyPress={allowAlphabetAndSpacesOnly}
                        />
                        <ErrorMessage name={`Chairperson.${index}.responsibilities`} component="div" className="text-danger" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <h5 className="mb-3 innerheader-new">
                <span>
                  <b>Members  and Chairperson </b>
                </span>
              </h5>
              <MembersTable
                title="Board of Governors"
                name="Members"
                formik={formik}
              // disabled={alreadySubmitted}
              />

              {/* {alreadySubmitted ? (
                        <div className="text-success text-end mt-4 ">
                            ✔ Your request has already been submitted for this academic year.
                        </div>
                    ) : ( */}


              <h5 className="mb-3 innerheader-new">
                <span>
                  <b>Land details of Taken over Society  </b>
                </span>
              </h5>



              <bie.Row className="px-2 pt-3 m-0">
                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                  <label className='mb-1'>
                    <b style={{ color: 'red' }}>* </b>
                    Whether the land is available in the name of society:
                  </label>


                  <Field as='select' name="society" className='form-control mb-2'>
                    <option value="">--Select--</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                  </Field>
                  <ErrorMessage name="society" component="div" className="text-danger" />

                </bie.Col>


                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label className='mb-1' > <b style={{ color: 'red' }}>* </b>Total Extent of Land(In Acres):</label>
                  <Field type='text' name="totalLand" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                  <ErrorMessage name="totalLand" component="div" className="text-danger" />
                </bie.Col>



                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b> Details of the land owned Survey No:</label>
                  <Field type='text' name="surveyNo" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                  <ErrorMessage name="surveyNo" component="div" className="text-danger" />
                </bie.Col>

                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>District Name:</label>
                  <Field as='select' name="distCode" className='form-control mb-2'
                    onChange={(e) => { GetMandlData(e?.target?.value); formik?.setFieldValue("mandalCode", ""); formik?.setFieldValue("villageCode", "") }}>
                    <option value="">--Select--</option>
                    {distlist?.map((d) => (
                      <option key={d.dist_code} value={d.dist_code}>
                        {d.dist_name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="distCode" component="div" className="text-danger" />
                </bie.Col>
                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Mandal Name:</label>
                  <Field as='select' name="mandalCode" className='form-control mb-2'
                    onChange={(e) => { GetVillegeData(formik?.values?.distCode, e?.target?.value,); formik?.setFieldValue("villageCode", "") }}>
                    <option value="">--select--</option>

                    {mdllist?.map((d) => (
                      <option key={d.mandal_code} value={d.mandal_code}>
                        {d.mandal_name}
                      </option>
                    ))}
                    {/* No data found */}


                  </Field>
                  <ErrorMessage name="mandalCode" component="div" className="text-danger" />
                </bie.Col>

                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>Village Name:</label>
                  <Field as='select' name="villageCode" className='form-control mb-2'>
                    <option value="">--Select--</option>
                    {vilglist !== undefined && vilglist !== null && vilglist !== '' && vilglist?.map((e, i) => {
                      return (<option key={i} value={e?.village_code}> {e?.village_name} </option>);
                    })}
                  </Field >
                  <ErrorMessage name="villageCode" component="div" className="text-danger" />
                </bie.Col>
                {/* No data found */}

                <bie.Col xs={12} md={3} lg={3} className="mb-3">
                  <label className="mb-1">
                    <b className="field-mandatory"> Sketch plan of own land drawn by the licensed surveyor and attested by the MRO
                    </b>
                  </label>
                  <input
                    type="file"
                    name="planbymroUpload"
                    className="form-control"
                    accept="application/pdf"
                    onChange={(e) => {
                      const filename = "planbymroUpload";  // dynamic filename
                      const path = "/Uploads/planbymroUpload/"; // destination folder
                      ImagePdfBucket(e, formik, path, "planbymroUpload", filename, "pdf");
                    }}
                  />
                  <ErrorMessage name="planbymroUpload" component="div" className="text-danger" />

                  {formik.values.planbymroUpload && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={() => viewImage(formik.values.planbymroUpload)}
                    ><FaEye />
                    </button>
                  )}
                </bie.Col>

                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>                Distance of the land from the college building (in km)
                  </label>
                  <Field type='text' name="distanceland" className='form-control mb-2' onKeyPress={(e) => { AllowFloats(e); }} onPaste={(e) => handlePaste(e)} />
                  <ErrorMessage name="distanceland" component="div" className="text-danger" />
                </bie.Col>




                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                  <label classname='mb-1' > <b style={{ color: 'red' }}>* </b>                 Change of Management & continuing the College in the same Building</label>
                  <Field as='select' name="changeMangement" className='form-control mb-2'>
                    <option value="">--Select--</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                  </Field>
                  <ErrorMessage name="changeMangement" component="div" className="text-danger" />

                </bie.Col>

                {formik?.values?.changeMangement === "No" && (
                  <div className="alert alert-warning mt-2" style={{ color: "brown", fontWeight: "200px", fontFamily: "sans-serif", fontSize: "18px" }}>
                    Apply for “Shifting the College” Service also, after obtaining the Approval for Change of Management
                  </div>
                )}


              </bie.Row>
              {/* <Row className="mt-4">
                <Col className="text-end">
                  <Button type="submit" variant="primary" className="btn-primary">
                    Submit
                  </Button>
                </Col>
              </Row> */}
              <div className="d-flex justify-content-end pb-3 pt-4"  >
                {paymentDone ? (
                  <div style={{ color: "green", fontWeight: "bold" }}>
                    ✅ Already submitted
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                  >
                    Submit
                  </button>
                )}
              </div>

            </Form>
          </FormikProvider>
        </div>
      </div>
    </>
  );
};
export default ManagementApplication;
